<div>
  <p-autoComplete name="chargeNumber" class="autoComplete" field="chargeNumber" placeholder="Type Charge Code Name/Number"
                  [suggestions]="chargeCodeOptions" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                  (completeMethod)="searchChargeCode($event)"
                  [(ngModel)]="selectedChargeCode" (onSelect)="onSelectChargeCode()" required>
    <ng-template let-chargeCode pTemplate="item">
      <div *ngFor="let property of properties; let i = index">
        {{chargeCode[property]}}
      </div>
    </ng-template>
  </p-autoComplete>
  <button style="float:right;" pButton type="button" (click)="clearChargeCode()" icon="fa fa-erase"></button>
</div>
